/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

 import React from 'react'

 import { Button, Input, FormFeedback, FormGroup, Label, Row, Col } from 'reactstrap'

 import {AppContext} from '../../AppContext';

 class OciObjectStorageAdmin extends React.Component
{
  credentialNameElement = null;

  componentDidMount()
  {
    this.getObjectStorageOptions();
    this.credentialNameElement.focus();
  }

  constructor(props)
  {
    super();

    this.state =
    {
      buttonDisabled: true,
      credentialName: 'ASTERIONDB_OBJECT_STORAGE',
      credentialNameValid: true,
      userOcid: '',
      userOcidValid: undefined,
      tenancyOcid: '',
      tenancyOcidValid: undefined,
      privateKey: '',
      privateKeyValid: undefined,
      fingerprint: '',
      fingerprintValid: undefined,
      compartmentOcid: '',
      compartmentOcidValid: undefined,
      region: '',
      regionValid: undefined,
      namespace: '',
      namespaceValid: undefined,
      inputDisabled: false,
      headerText: null
    }

    this.getObjectStorageOptions = this.getObjectStorageOptions.bind(this);
    this.createCredential = this.createCredential.bind(this);
    this.setButtonDisabled = this.setButtonDisabled.bind(this);
    this.requiredField = this.requiredField.bind(this);
  }

  async createCredential(event)
  {
    this.setState({buttonDisabled: true});
    event.preventDefault();

    var bodyData = {};
    bodyData.credentialName = this.state.credentialName;
    bodyData.userOcid = this.state.userOcid;
    bodyData.tenancyOcid = this.state.tenancyOcid;
    bodyData.privateKey = this.state.privateKey;
    bodyData.fingerprint = this.state.fingerprint;
    bodyData.region = this.state.region;
    bodyData.namespace = this.state.namespace;
    bodyData.compartmentOcid = this.state.compartmentOcid;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createObjectStorageCredential', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error creating object storage credential.');
    }

    this.context.postNotification('info', 'Object storage credential created.');
    this.setState({ inputDisabled: true });
  }

  async getObjectStorageOptions()
  {

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectStorageOptions');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading website profile');

    this.setState({...result.jsonData, inputDisabled: undefined === result.jsonData.credentialName ? false : true});
    if (undefined === result.jsonData.credentialName)
      this.setState({headerText: 'Provide the required information and press Create Credential.'});
    else
      this.setState({headerText: 'Object storage credential set. Changes not allowed.'});
  }

  render()
  {    
    let valueRequired = 'A value is required for this field.';

    return(
      <div>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Row><Col><h2>{this.state.headerText}</h2></Col></Row>
          <Label for="credentialName" sm="2">Credential Name</Label>
          <Col sm="3">
            <Input type="text" id="credentialName" placeholder='ASTERIONDB_OBJECT_STORAGE' 
              value={this.state.credentialName} onChange={this.requiredField}
              invalid={(undefined === this.state.credentialNameValid ? undefined : !this.state.credentialNameValid)} 
              valid={(undefined === this.state.credentialNameValid ? undefined : this.state.credentialNameValid)} 
              disabled={this.state.inputDisabled} innerRef={(input) => this.credentialNameElement = input} 
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="userOcid" sm="2">User Ocid</Label>
          <Col sm="3">
            <Input type="text" id="userOcid" title='OCI-->Identity & Security-->Users'
              value={this.state.userOcid} onChange={this.requiredField}
              invalid={(undefined === this.state.userOcidValid ? undefined : !this.state.userOcidValid)} 
              valid={(undefined === this.state.userOcidValid ? undefined : this.state.userOcidValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="tenancyOcid" sm="2">Tenancy Ocid</Label>
          <Col sm="3">
            <Input type="text" id="tenancyOcid" title='OCI-->Governance & Administration-->Tenancy Details'
              value={this.state.tenancyOcid} onChange={this.requiredField}
              invalid={(undefined === this.state.tenancyOcidValid ? undefined : !this.state.tenancyOcidValid)} 
              valid={(undefined === this.state.tenancyOcidValid ? undefined : this.state.tenancyOcidValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="compartmentOcid" sm="2">Compartment Ocid</Label>
          <Col sm="3">
            <Input type="text" id="compartmentOcid" title='OCI-->Identity & Security-->Compartments'
              value={this.state.compartmentOcid} onChange={this.requiredField}
              invalid={(undefined === this.state.compartmentOcidValid ? undefined : !this.state.compartmentOcidValid)} 
              valid={(undefined === this.state.compartmentOcidValid ? undefined : this.state.compartmentOcidValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="region" sm="2">Region</Label>
          <Col sm="3">
            <Input type="text" id="region" title='OCI-->Governance & Administration-->Region Management (e.g. us-phoenix-1)'
              value={this.state.region} onChange={this.requiredField}
              invalid={(undefined === this.state.regiondValid ? undefined : !this.state.regionValid)} 
              valid={(undefined === this.state.regionValid ? undefined : this.state.regionValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="namespace" sm="2">Object Storage Namespace</Label>
          <Col sm="3">
            <Input type="text" id="namespace" title='OCI-->Governance & Administration-->Tenancy Details'
              value={this.state.namespace} onChange={this.requiredField}
              invalid={(undefined === this.state.namespaceValid ? undefined : !this.state.namespaceValid)} 
              valid={(undefined === this.state.namespaceValid ? undefined : this.state.namespaceValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        { !this.state.inputDisabled &&
          <FormGroup row style={{paddingTop: "10px"}}>
            <Label for="privateKey" sm="2">Private Key</Label>
            <Col sm="3">
              <Input type="textarea" id="privateKey" title='Your OCI API Private Key'
                value={this.state.privateKey} onChange={this.requiredField}
                invalid={(undefined === this.state.privateKeyValid ? undefined : !this.state.privateKeyValid)} 
                valid={(undefined === this.state.privateKeyValid ? undefined : this.state.privateKeyValid)} 
              />
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        }
        <FormGroup row style={{paddingTop: "10px"}}>
          <Label for="fingerprint" sm="2">Fingerprint</Label>
          <Col sm="3">
            <Input type="text" id="fingerprint" title="Your OCI API Private Key's fingerprint"
              value={this.state.fingerprint} onChange={this.requiredField}
              invalid={(undefined === this.state.fingerprintValid ? undefined : !this.state.fingerprintValid)} 
              valid={(undefined === this.state.fingerprintValid ? undefined : this.state.fingerprintValid)} 
              disabled={this.state.inputDisabled}
            />
            <FormFeedback valid={false}>{valueRequired}</FormFeedback>
          </Col>
        </FormGroup>
        { !this.state.inputDisabled &&
          <Row style={{paddingTop: "10px"}}>
            <Col sm={{ size: 2, offset: 2 }}>
              <Button onClick={this.createCredential} disabled={this.state.buttonDisabled} color="primary">Create Credential</Button>
            </Col>
          </Row>
        }
      </div>
    );
  }  

  requiredField(event)
  {
    let valid = ("" === event.target.value ? false : true);
    this.setState({[event.target.id]: event.target.value, [event.target.id + 'Valid']: valid}, this.setButtonDisabled);
  }

  setButtonDisabled()
  {
    let disabled = true;
    if (this.state.credentialNameValid && this.state.fingerprintValid && this.state.namespaceValid && this.state.privateKeyValid &&
        this.state.compartmentOcidValid && this.state.regionValid && this.state.tenancyOcidValid && this.state.userOcidValid)
      disabled = false;
    this.setState({buttonDisabled: disabled});
  }
}

OciObjectStorageAdmin.contextType = AppContext;

export default OciObjectStorageAdmin
